class ArnFooter extends HTMLElement {
  connectedCallback() {
    this.querySelector('#footer-other-sites-desktop-toggle')?.addEventListener('click', this.toggleOtherSitesRow.bind(this));

   
    this.querySelectorAll('.arn-footer-mobile-toggle').forEach((title) => {
      const next = title.nextElementSibling;
      const caret = title.querySelector('.icon-caret');

      if (next && next.tagName === 'UL') {
        next.classList.add('tw-hidden', 'tw-overflow-hidden', 'tw-transition-all', 'tw-duration-300');

        title.addEventListener('click', () => {
          const isHidden = next.classList.contains('tw-hidden');

          if (isHidden) {
            next.classList.remove('tw-hidden');
            next.style.maxHeight = '0px';
            requestAnimationFrame(() => {
              next.style.maxHeight = next.scrollHeight + 'px';
            });
            caret?.classList.add('tw-rotate-180');
          } else {
            next.style.maxHeight = next.scrollHeight + 'px';
            requestAnimationFrame(() => {
              next.style.maxHeight = '0px';
            });
            next.addEventListener('transitionend', function handler() {
              next.classList.add('tw-hidden');
              next.style.maxHeight = '';
              next.removeEventListener('transitionend', handler);
            });
            caret?.classList.remove('tw-rotate-180');
          }
        });
      }
    });
  }

  toggleOtherSitesRow() {
    const row = this.querySelector('#footer-other-sites-row');
    if (row) {
      row.classList.toggle('sd:tw-hidden');
      window.scrollTo({ top: document.body.scrollHeight, behavior: 'smooth' });
    }
  }
}

customElements.define("arn-footer", ArnFooter);